import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

import { DialogService, TranslationService } from '@sdbn/common';
import { FilterAdministrationContext } from '../../filter-administration.context';
import { FilterCondition } from '../../filter-administration.model';
import { FilterEditorRegistryService } from '../../filter-editor-registry.service';
import { FilterService } from '../../filter.service';

const source = 'app-filter-condition';

@Component({
  selector: 'app-filter-condition',
  templateUrl: './filter-condition.component.html',
  styleUrls: ['./filter-condition.component.scss']
})
export class FilterConditionComponent implements OnInit, OnDestroy {

  nameDictionaryKey;

  highlightSameType = false;
  selected = false;

  filterAdministrationContext: FilterAdministrationContext;
  filterAdministrationContextSubscription: Subscription;

  filterCondition: FilterCondition;

  @Input() set setFilterCondition(filterCondition: FilterCondition) {
    this.filterCondition = filterCondition;
    this.nameDictionaryKey = this.filterEditorRegistryService.getConditionType(filterCondition.type)?.nameDictionaryKey;
    this.updateSelection();
  }

  @Input() set setfilterAdministrationContext(filterAdministrationContext: FilterAdministrationContext) {
    this.filterAdministrationContext = filterAdministrationContext;
    this.updateSelection();
    this.filterAdministrationContextSubscription = this.filterAdministrationContext.contextChange$.subscribe(
      change => {
        try {
          if (change.key === 'dragged-condition-type') {
            this.highlightSameType = this.filterCondition?.type === change.value?.type;
          }

          if (change.key === 'selected-filter-condition-changed') {
            this.selected = this.filterCondition === change.value;
          }

        } catch (error) {

        }
      }
    );
  }

  constructor(
    public translationService: TranslationService,
    private dialog: MatDialog,
    private filterService: FilterService,
    private filterEditorRegistryService: FilterEditorRegistryService,
    private dialogService: DialogService
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    if (this.filterAdministrationContextSubscription != null) {
      this.filterAdministrationContextSubscription.unsubscribe();
    }
  }

  public select() {
    this.filterAdministrationContext.setSelectedFilterCondition(this.filterCondition, source);
  }

  public onDragConditionStart(event: DragEvent) {
    event.dataTransfer.effectAllowed = "move";
    // IOS geht nur wenn gesetzt
    event.dataTransfer.setData("text/plain", "");

    this.filterAdministrationContext.setDraggedFilterCondition(this.filterCondition, source);
  }


  public onDragConditionEnd(event: DragEvent) {
    event.dataTransfer.effectAllowed = "move";
    // IOS geht nur wenn gesetzt
    event.dataTransfer.setData("text/plain", "");

    this.filterAdministrationContext.setDraggedFilterCondition(null, source);
  }

  public deleteCondition() {

      this.dialogService.showConfirm(
        'tmc-yard.ui.admin.filter-administration.filter-condition.delete.confirm-dialog.title',
       'tmc-yard.ui.admin.filter-administration.filter-condition.delete.confirm-dialog.message'
      ).afterClosed().subscribe(() => {
        this.filterCondition.deleted = true;
        if (this.filterCondition.id <= 0) {
          this.filterService.removeConditionFromFilter(this.filterAdministrationContext.getFilter(), this.filterCondition);
        }
        this.filterAdministrationContext.setSelectedFilterCondition(null, source);
        this.filterAdministrationContext.getFilter().dirty = true;
      });

  }

  private updateSelection() {
    if (this.filterCondition != null && this.filterAdministrationContext != null) {
      this.selected = this.filterCondition === this.filterAdministrationContext.getSelectedFilterCondition();
    }
  }
}
